import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { Text } from '@carnica/ui-kit';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _HeadingGroup = function _HeadingGroup(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    heading = _ref.heading,
    subheading = _ref.subheading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 2 : _ref$size,
    className = _ref.className,
    isInvertColor = _ref.isInvertColor,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? true : _ref$isResponsive;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', "size--".concat(size || 1), {
      responsive: isResponsive
    }, className),
    "data-t-id": "components-HeadingGroup"
  }, /*#__PURE__*/React.createElement(Text, {
    align: align,
    className: cn('heading'),
    color: isInvertColor ? 'primary-invert' : 'primary',
    tagName: "h".concat(size + 1)
  }, heading), /*#__PURE__*/React.createElement(Text, {
    align: align,
    className: cn('subheading'),
    color: isInvertColor ? 'secondary-invert' : 'secondary',
    tagName: "div"
  }, subheading));
};
export var HeadingGroup = compose(enhancedConnect({
  heading: PropTypes.string,
  subheading: PropTypes.string,
  size: PropTypes.oneOf([0, 1, 2, 3, 4]),
  align: PropTypes.oneOf([undefined, 'left', 'center', 'right']),
  className: PropTypes.string,
  isInvertColor: PropTypes.bool,
  isResponsive: PropTypes.bool
}), withAutoMetric.Params(function (props) {
  return {
    title: props.heading
  };
}))(_HeadingGroup);
HeadingGroup.defaultProps = {
  isResponsive: true
};